import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import TiptapFloatingToolbar from './TiptapFloatingToolbar';
import TiptapStaticToolbar from './TiptapStaticToolbar';
/**
 * Главный компонент тулбара для текстового редактора
 * Объединяет статический и всплывающий тулбары
 *
 * @param props - Пропсы компонента
 */
const TiptapToolbar = (props) => {
    return (_jsxs(_Fragment, { children: [_jsx(TiptapFloatingToolbar, { editor: props.editor, zoom: props.zoom, stagePosition: props.stagePosition }), _jsx(TiptapStaticToolbar, { editor: props.editor, onFontSizeChange: props.onFontSizeChange, onBackgroundColorChange: props.onBackgroundColorChange, onTextColorChange: props.onTextColorChange, onTextAlignChange: props.onTextAlignChange, currentFontSize: props.currentFontSize, currentBackgroundColor: props.currentBackgroundColor, currentTextColor: props.currentTextColor, currentTextAlign: props.currentTextAlign, showMarkdownSource: props.showMarkdownSource, onMarkdownSourceToggle: props.onMarkdownSourceToggle })] }));
};
export default TiptapToolbar;
